











































import Vue from 'vue';

import _ from 'lodash';

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import unsubscribeForm from '@/components/molecules/unsubscribeForm.vue';
import reUnsubscribe from '@/components/molecules/reUnsubscribe.vue';
import successUnsubscribe from '@/components/molecules/successUnsubscribe.vue';

import { getCustPreference } from '@/store/models.d';
import customerPreference from '@/store/modules/customerPreference';

@Component({
  components: {
    'unsubscribe-form': unsubscribeForm,
    're-unsubscribe': reUnsubscribe,
    'success-unsubscribe': successUnsubscribe,
  },
})
export default class Unsubscribes extends Vue { // eslint-disable-next-line
  // WATCHS
  @Watch('$route', { immediate: true, deep: true }) // eslint-disable-next-line
  routeChanged(to: any): void {
    this.customerID = to.query.customerId;
    document.title = to.meta.title || 'Unsubscribe Page';
  }

  // DATA
  customerID = '';

  checkedList = {};

  toggle = {
    subscribeForm: true,
    reSubscribe: false,
    success: false,
    loadings: false,
  };

  loadings = {
    page: true,
    first: false,
    second: false,
  }

  get getCustomerPreference() {
    return this.$store.state.customerPreference.customerPreference || {};
  }

  async created() {
    const customerPreferenceQuery: getCustPreference | any = {
      campaignId: this.$route.query.campaignId,
      token: this.$route.query.token,
    };

    if (this.$route.name !== 'error') {
      await customerPreference.check(customerPreferenceQuery);

      if (_.isEmpty(this.getCustomerPreference)) {
        this.$router.push({
          path: '/error',
          name: 'error',
          params: { message: 'Page not found. Please try again later.' },
        });
      }

      this.loadings.page = false;

      switch (!_.isEmpty(this.getCustomerPreference)) {
        case false:
          this.$router.push({
            path: '/error',
            name: 'error',
            params: { message: this.getCustomerPreference.message },
          });
          break;

        default:
          break;
      }
    }
  }

  // METHODS
  public async unsubscribeFormClick(checkedList: any): Promise<any> {
    this.loadings.first = true;

    const params: any = {
      value: 'UNSUBSCRIBE',
      checkedList,
    };

    await customerPreference.update({
      campaignId: this.$route.query.campaignId,
      token: this.$route.query.token,
      merchantId: this.$route.query.merchantId,
      params,
    });

    this.toggle.subscribeForm = false;
    this.toggle.reSubscribe = true;
    this.loadings.first = false;

    this.checkedList = checkedList;
  }

  public async reUnsubscribeClick(value: any): Promise<any> {
    this.loadings.second = true;

    const params: any = {
      value: 'MAX_1_PER_DAY',
    };

    await customerPreference.update({
      campaignId: this.$route.query.campaignId,
      token: this.$route.query.token,
      merchantId: this.$route.query.merchantId,
      params,
    });

    this.toggle.success = value.reClick;
    this.toggle.subscribeForm = false;
    this.toggle.reSubscribe = false;
    this.loadings.second = false;
  }
}

